import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { useAdminSupport } from '../../share/hook/useAdminSupport';
import { useAdminSupportListStore } from '../../share/store/adminSupportStore';
import SupportInfo from './SupportInfo';
import EmptyList from '../../share/component/EmptyList';
import SupportViewer from './SupportViewer';
import { SupportData } from '../../../shared/dto/EntityRepository';
import { useAuth } from '../../../shared/hooks/useApi/useAuth';
import { useAuthTokenStore } from '../../../shared/store/authStore';


const SupportList: React.FC = () => {
  const { user } = useAuth();
  const { authToken } = useAuthTokenStore();
  const { supportList, activeSupport, setActiveSupport, getSupportList } = useAdminSupport();
  const { sortData, pageSize } = useAdminSupportListStore();
  const [selectedId, setSelectedId] = useState<string>("");
  const supportListRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (supportListRef.current) {
      supportListRef.current.focus();
    }
  }, [supportListRef]);

  useEffect(() => {
    const getSupportListWithApi = async () => {
      if (!user) return;
      if (!authToken) return;
      console.log("getting support list...");
      await getSupportList(user.aui, { page: 1, size: pageSize, sortData: sortData, filterData: {} });
    }
    getSupportListWithApi();
  }, [user, sortData, authToken]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!supportList.length) return;
    if (e.key === 'ArrowDown') {
      const newIndex = supportList.findIndex(each => each.id === selectedId) + 1;
      if (newIndex < supportList.length) {
        const newId = supportList[newIndex].id;
        changeActiveSupport(newId);
      }
    } else if (e.key === 'ArrowUp') {
      const newIndex = supportList.findIndex(each => each.id === selectedId) - 1;
      if (newIndex >= 0) {
        const newId = supportList[newIndex].id;
        changeActiveSupport(newId);
      }
    }
  };

  const handleClick = (selectedId: string) => {
    changeActiveSupport(selectedId);
  };

  const changeActiveSupport = (newId: string) => {
    const getSupportWithApi = async () => {
      // console.log("getting support...");
      // await getSupport(newId);
      setActiveSupport(supportList.find(each => each.id === newId) || null);
      setSelectedId(newId);
    }
    if (newId !== selectedId) {
      getSupportWithApi();
    }
  };

  return (
    <SupportListContainer
      tabIndex={0}
      ref={supportListRef}
      onKeyDown={handleKeyDown}>
      <SupportListComp>
        {supportList.map((each: SupportData) =>
          <SupportInfo
            key={each.id}
            data={each}
            isSelected={each.id === activeSupport?.id}
            handleClick={() => handleClick(each.id)}
          />
        )}
        {supportList.length === 0 && <EmptyList message={"support messages"} />}
      </SupportListComp>
      <SupportViewer />
    </SupportListContainer>
  );
};


const SupportListContainer = styled.article`
  width: 100%;
  height: calc(80vh - 2vh);
  display: flex;
  outline: none;
`;

const SupportListComp = styled.section`
  flex: 1;
  width: auto;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-bottom: 1px solid ${({ theme }) => theme.colors.color_Gray_04};
`;


export default SupportList;